module.exports = __webpack_public_path__ + "static/img/Galaxy_Watch_Active2.331cecea.jpg";